import { render } from "./TermEditTableRow.vue?vue&type=template&id=9f6f531e&scoped=true&ts=true"
import script from "./TermEditTableRow.vue?vue&type=script&lang=ts"
export * from "./TermEditTableRow.vue?vue&type=script&lang=ts"

import "./TermEditTableRow.vue?vue&type=style&index=0&id=9f6f531e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6f531e"]])

export default __exports__